// extracted by mini-css-extract-plugin
export default {"withdrawPageWrapper":"Withdraw_withdrawPageWrapper__8ovAC","withdrawContentWrapper":"Withdraw_withdrawContentWrapper__8AasQ","withdrawContents":"Withdraw_withdrawContents__gParY"};